import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

// Services
import { HttpService } from 'src/app/modules/shared/services/http.service';

@Injectable({
    providedIn: 'root'
})

export class SharedTemplateService {
    baseConfigURL: string;

    constructor(
        private httpService: HttpService) {
        this.baseConfigURL = environment.configUrlV2;
    }

    getModuleTemplates(moduleId: number): Observable<any[]> {
        return this.httpService.getAll(`${environment.configUrlV2}/Template/SelectList/Module/${moduleId}`);
    }

    getTemplatesSectionsFieldsForSavedSearch(mainModuleId: number, associateModuleId: number, templateId: number): Observable<any[]> {
        return this.httpService.getAll(
            `${this.baseConfigURL}/Template/SectionFieldsForSavedSearch/MainModule/${mainModuleId}/DependantModule/${associateModuleId}/Template/${templateId}`
        );
    }

    getModuleColumnSettingForSavedSearch(moduleId: number, channelId: number): Observable<any> {
        return this.httpService.getAll(
            `${this.baseConfigURL}/ColumnSetting/GetSavedSearchColumnSetting/Module/${moduleId}/Channel/${channelId}`
        );
    }

    getTemplateDetails(moduleId: number, templateId: number): Observable<any> {
        return this.httpService.getById(`${this.baseConfigURL}/Template/Module/${moduleId}/Template/${templateId}`);
    }

    getTemplateSections(moduleId: number, templateId: number): Observable<any[]> {
        return this.httpService.getAll(`${environment.configUrlV2}/Section/SelectList/Module/${moduleId}/Template/${templateId}`);
    }

    getSections(moduleId: number): Observable<any[]> {
        return this.httpService.getAll(`${environment.configUrlV2}/Section/SelectList/Module/${moduleId}`);
    }

    getTemplateSectionsForFormBuild(moduleId: number, templateId: number): Observable<any[]> {
        return this.httpService.getAll(`${environment.configUrlV2}/Template/SectionFieldsForFormBuild/Module/${moduleId}/Channel/${templateId}`);
    }

    getTemplateSectionsForQuestionnaireRules(moduleId: number, templateId: number): Observable<any[]> {
        return this.httpService.getAll(`${environment.configUrlV2}/Template/SectionFieldsForFormBuildOther/Module/${moduleId}/Channel/${templateId}`);
    }
}
